import styled from 'styled-components';
import { Tabs } from 'antd';

export const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin: 0;
    padding: 8px 0 0 0;
    background: white;
    border-bottom: 1px solid #f0f0f0;
    overflow: visible;
  }

  .ant-tabs-nav-list {
    width: auto;
    display: flex;
    gap: 16px;
    flex-wrap: nowrap;
    margin: 0 auto;
    max-width: 800px;
  }

  .ant-tabs-tab {
    padding: 0;
    margin: 0 !important;
    transition: all 0.3s ease;
    border-radius: 8px 8px 0 0;
    min-width: 120px;
    max-width: 160px;
    
    .ant-tabs-tab-btn {
      width: 100%;
      display: flex;
      justify-content: center;
      color: #1890ff !important;
    }
    
    &:hover {
      background: #f3f3f1;
      .ant-tabs-tab-btn {
        color: black !important;
      }
    }

    &.ant-tabs-tab-active {
      background: #f3f3f1;
      
      .ant-tabs-tab-btn {
        color: black !important;
      }
    }
  }

  .ant-tabs-ink-bar {
    display: none;
  }

  .ant-tabs-tab + .ant-tabs-tab {
    margin: 0;
  }

  .ant-tabs-nav-operations {
    position: relative !important;
    
    .ant-tabs-nav-more {
      padding: 8px 12px;
      border-radius: 8px 0 0 0;
      min-width: auto;
      
      &:hover {
        background: #f3f3f1;
        color: black;
      }
    }
  }

  @media (max-width: 768px) {
    .ant-tabs-nav {
      padding: 8px 0 0 0;
    }
    
    .ant-tabs-nav-list {
      width: 100%;
      gap: 6px;
    }

    .ant-tabs-tab {
      min-width: 80px;
      max-width: none;
      flex: 1;

      .ant-tabs-tab-btn {
        width: 100%;
      }
    }
  }

  @media (max-width: 480px) {
    .ant-tabs-tab {
      min-width: 60px;
    }
    
    .ant-tabs-nav-list {
      gap: 4px;
    }
  }
`;

export const TabContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  opacity: ${({ isActive }) => (isActive ? 1 : 0.85)};
  color: ${({ isActive }) => (isActive ? '#1890ff' : '#666')};
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover {
    opacity: 1;
    color: #1890ff;
  }

  @media (max-width: 480px) {
    padding: 8px 6px;
    gap: 4px;
  }
`;

export const TabIcon = styled.div`
  font-size: 14px;
  display: flex;
  align-items: center;
  flex-shrink: 0;

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

export const TabLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;